import { defineStore } from 'pinia'

import type {
	IFetchApiControllerList,
	IFetchApiExportController,
	IFetchApiExportControllerTemplate,
	IFetchControllerTypeList
} from '~/portal/api'
import {
	fetchApiControllerList,
	fetchApiDeleteControllerDB,
	fetchApiExportController,
	fetchApiExportControllerTemplate,
	fetchControllerTypeList
} from '~/portal/api'
import type { IPControllersStoreTypes } from '~/portal/stores'

import type { components } from '../../../../schema.ts'

export const useControllersStore = defineStore('controllersStore', {
	state: (): IPControllersStoreTypes => ({
		controllerList: [],
		controllerTypeList: [],
		totalCount: 0
	}),
	actions: {
		async fetchControllerList(payload: IFetchApiControllerList) {
			const response = await fetchApiControllerList(payload)
			if (!response?.data) return

			let data: components['schemas']['GetController'][] = []
			let total = 0

			if ('results' in response.data && 'count' in response.data) {
				data = response.data.results
				total = response.data.count
			} else if (Array.isArray(response.data)) {
				data = response.data
				total = response.data.length
			}

			this.totalCount = total

			const pageNum = payload.params?.page ? +payload.params.page : 1
			if (pageNum > 1) {
				this.controllerList = [...this.controllerList, ...data]
			} else {
				this.controllerList = data
			}
		},
		async fetchControllerTypeList(payload: IFetchControllerTypeList) {
			const response = await fetchControllerTypeList({
				...payload,
				params: {
					type: 'controller'
				}
			})
			if (response?.data) {
				this.controllerTypeList = response.data
			}
		},
		async exportController(payload: IFetchApiExportController) {
			return await fetchApiExportController(payload)
		},
		async exportControllerTemplate(payload: IFetchApiExportControllerTemplate) {
			return await fetchApiExportControllerTemplate(payload)
		},
		async deleteDbController(payload: { token: string; id: number }) {
			return await fetchApiDeleteControllerDB(payload)
		}
	}
})
